import Utils from "./Utils.js";
import EventEmitter from "./EventEmitter.js";
import UI from "./UI.js";
import AudioEffects from "./AudioEffects.js";
import Config from "./Config.js";
export default class Game extends EventEmitter {
  constructor(keyword = null) {
    super();
    this.HAS_STARTED = false;
    this.PLAY_MODE = false;
    this.COUNT_INDIVIDUAL_KEY_ERROR = true;
    this.KEYWORD_TO_GUESS = keyword.replace("_", " ");
    this.initGame();
  }

  async initGame() {
    this.initialData = await Utils.loadJSON("json/game/gameInstructions2.json");
    this.extraData = await Utils.loadJSON("json/game/extraInstructions.json");

    this.extraDataKeys = {
      winning: [
        "AI_winning_1",
        "AI_winning_2",
        "AI_winning_3",
        "AI_winning_4",
        "AI_winning_5",
        "AI_winning_6",
        "AI_winning_7",
        "AI_winning_8",
        "AI_winning_9",
        "AI_winning_10",
      ],
      losing: [
        "AI_loosing_1",
        "AI_loosing_2",
        "AI_loosing_3",
        "AI_loosing_4",
        "AI_loosing_5",
        "AI_loosing_6",
        "AI_loosing_7",
        "AI_loosing_8",
        "AI_loosing_9",
      ],
    };

    this.newWord();
    console.log("game initialized");
    this.emit("ready", []);
  }

  newWord() {
    // this.randomItem =
    //   this.gameData.wordList[
    //     Math.floor(Math.random() * this.gameData.wordList.length)
    //   ];
    // this.word = this.randomItem.word;
    // this.hint = this.randomItem.hint;
    this.word = this.KEYWORD_TO_GUESS.replace("_", " ");

    this.maxGuesses = 5; //this.word.length >= 5 ? 8 : 6;
    this.correctLetters = [];
    this.incorrectLetters = [];
    this.wordCopy = this.word;

    this.filterSpace();

    // generate the space for each letter
    // console.log(this.hint + " in " + this.word.length + " letters");
    return this.word;
  }

  filterSpace() {
    if (this.word.indexOf(" ") == -1) return;
    this.wordCopy = this.wordCopy.replace(/ /g, "%");
    // count the number of spaces
    let spaceCount = (this.word.match(/ /g) || []).length;
    if (spaceCount > 1) {
      for (let i = 0; i < spaceCount; i++) {
        this.correctLetters.push(" ");
      }
    } else this.correctLetters.push(" ");
  }

  get activeLetter() {
    const shift = this.activeLetters.shift();
    this.activeLetters.push(shift);
    console.log(this.activeLetters);
    return shift;
  }

  set clueIndex(index) {
    this.clueIndexValue = index;
    const letter = this.word[index];
    const key = { key: letter };
    this.clueLetter = letter;
    this.keyPressed(key, true);
  }

  get clueIndex() {
    return this.word.indexOf(this.clueLetter);
  }

  getLetterByIndex(index) {
    return this.activeLetters[index];
  }

  getActiveLetters(letters) {
    this.activeLetters = [];
    for (let i = letters.length - this.word.length; i < letters.length; i++) {
      this.activeLetters.push(letters[i]);
    }
    console.log(this.activeLetters);
  }

  keyPressed(e, fromClue = false) {
    /**
     * GAME CONDITIONS :
     * 1) SHOULD MATCH THE WORD LETTERS
     * 2) IN ANY POSITION
     * 3) ANY NUMBER OF TIME NECESSARY
     * 4) IF WRONG OR LETTER ALREADY DECOUNTED, IT SHOULD COUNT AS ERROR
     *
     *  !! check for the default letter it should not be counted as error
     */

    console.log("key pressed for the game", this.word);
    let key = e.key.toLowerCase();
    console.log(key);
    let matchingKey = [];

    // verify if the key is a letter and present in the word
    if (key.match(/^[A-Za-z-]+$/) && this.wordCopy.includes(key)) {
      // if (this.clueLetter == key && !fromClue) this.clueLetter = null;
      // else this.correctLetters.push(key);
      this.correctLetters.push(key);

      //stop after the first match
      let firstMatch = false;
      for (let i = 0; i < this.wordCopy.length; i++) {
        if (this.wordCopy[i] == key && !firstMatch) {
          // --> check if index is not clue index
          matchingKey = [key, i];
          firstMatch = true;

          // // if the key is already in the correct letters, but doesn't matches this.clueIndexValue
          // // then it should be added to the correct letters
          // if (this.correctLetters.includes(key) && i != this.clueIndex) {
          //   this.correctLetters.push(key);
          // }
        }
      }

      // remove the key from this.wordCopy only if has been pressed by the user.
      // this.wordCopy = this.wordCopy.replace(key, !fromClue ? "%" : key);
      // this.wordCopy = this.wordCopy.replace(key, "%");
      this.wordCopy = Utils.replaceAt(
        this.wordCopy,
        fromClue ? this.clueIndexValue : matchingKey[1],
        "%"
      );
    } else {
      this.maxGuesses--;
    }

    console.log("correct letters", this.correctLetters, this.wordCopy);

    // if (
    //   key.match(/^[A-Za-z]+$/) &&
    //   !this.incorrectLetters.includes(` ${key}`) &&
    //   !this.correctLetters.includes(key)
    // ) {
    //   if (this.word.includes(key)) {
    //     for (let i = 0; i < this.word.length; i++) {
    //       if (this.word[i] == key) {
    //         this.correctLetters += key;
    //         //  inputs.querySelectorAll("input")[i].value = key;
    //         matchingKey = [key, i];
    //       }
    //     }
    //   } else {
    //     this.maxGuesses--;
    //     this.incorrectLetters.push(` ${key}`);
    //   }
    //   //   guessLeft.innerText = maxGuesses;
    //   //   wrongLetter.innerText = incorrectLetters;
    //   console.log("incorrectLetters", this.incorrectLetters);
    //   console.log("correctLetters", this.correctLetters);
    //   console.log("guesses left", this.maxGuesses);
    // } else if (
    //   this.incorrectLetters.includes(` ${key}`) &&
    //   !this.word.includes(key)
    // ) {
    //   this.maxGuesses--;
    //   this.incorrectLetters.push(` ${key}`);
    // } else if (this.word.includes(key) && this.correctLetters.includes(key)) {
    //   this.maxGuesses--;
    //   this.incorrectLetters.push(` ${key}`);
    // }
    setTimeout(this.checkWin.bind(this), 100);
    return matchingKey;
  }

  checkWin() {
    if (this.correctLetters.length == this.word.length) {
      // win
      console.log("win");
      UI.set(
        "hint",
        `${Utils.translate(
          "UI_Winning",
          Config.dictionary
        )} ${this.word.toUpperCase()}`
      );
      setTimeout(() => {
        AudioEffects.winning.currentTime = 0;
        AudioEffects.winning.play();
      }, 200);
      this.emit("win", []);
      // return this.newWord();
    } else if (this.maxGuesses < 1) {
      // lose
      // console.error("lose");
      console.log("LOSE");
      console.log("Answer was : " + this.word);
      UI.set(
        "hint",
        `${Utils.translate(
          "UI_Losing",
          Config.dictionary
        )} ${this.word.toUpperCase()}`
      );
      setTimeout(() => {
        AudioEffects.play("gameover");
        // AudioEffects.gameover.currentTime = 0;
        // AudioEffects.gameover.play();
      }, 500);
      this.emit("gameover", []);
    }
  }
}
